import { Box, Card, Text } from '@zillow/constellation-10';

import AccessibleCardLink from './AccessibleCardLink';
import { tileContentStyles } from './styles';

type TourCountTileProps = {
  count: number;
  label: string;
  testId: string;
  href?: string;
  onClick?: () => void;
};

const TourCountTile = ({ count, label, testId, href, onClick }: TourCountTileProps) => {
  const content = (
    <Card.Content>
      <Box css={tileContentStyles}>
        <Text textStyle="heading-xs">{count}</Text>
        <Text textStyle="body-sm" color="text.subtle">
          {label}
        </Text>
      </Box>
    </Card.Content>
  );

  if (href) {
    return (
      <AccessibleCardLink
        href={href}
        ariaLabel={`${count} ${label}, view in tour calendar`}
        testId={testId}
        rootCss={{ flex: 1 }}
        onClick={onClick}
      >
        {content}
      </AccessibleCardLink>
    );
  }

  return (
    <Card.Root data-testid={testId} elevated={false} css={{ flex: 1 }}>
      {content}
    </Card.Root>
  );
};

export default TourCountTile;
